import * as React from "react";
import { withStyles } from "src/decorators";
import styled from "styled-components";

const WrapperEl = styled.div`
  overflow: hidden;
  position: relative;

  @keyframes load {
    from {
      left: -150px;
    }
    to {
      left: 100%;
    }
  }

  :before {
    content: "";
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    background: linear-gradient(
      to right,
      transparent 0%,
      white 50%,
      transparent 100%
    );
    animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }
`;

export const SkeletonWrapper = withStyles((props: any) => (
  <WrapperEl {...props} />
));
